import React from "react";

const Spinner = () => {
  return (
    <div className="spinner-wrapper">
      <img
        src="ballSpin.png"
        alt="spinning pokeball loader"
        className="ball-spin"
      />
    </div>

  );
};

export default Spinner;
